<template>
  <div class="home-page container-md">
    <h2>ValidateForm 验证表单 和 ValidateInput 验证 Input 组件</h2>
    <p>具有数据收集、校验和提交功能的表单。支持多种预设规则，自定义规则等。详见代码。</p>

    <h4>演示</h4>
    <div class="login-page mx-auto p-3 w-50">
    <h5 class="my-4 text-center">注册者也账户</h5>
    <validate-form @form-submit="onFormSubmit">
      <div class="mb-3">
        <label class="form-label">邮箱地址</label>
        <validate-input
          :rules="emailRules" v-model="formData.email"
          placeholder="请输入邮箱地址"
          type="text"
        />
      </div>
      <div class="mb-3">
        <label class="form-label">昵称</label>
        <validate-input
          :rules="nameRules" v-model="formData.nickName"
          placeholder="请输入昵称"
          type="text"
        />
      </div>
      <div class="mb-3">
        <label class="form-label">密码</label>
        <validate-input
          type="password"
          placeholder="请输入密码"
          :rules="passwordRules"
          v-model="formData.password"
        />
      </div>
      <div class="mb-3">
        <label class="form-label">重复密码</label>
        <validate-input
          type="password"
          placeholder="请再次密码"
          :rules="repeatPasswordRules"
          v-model="formData.repeatPassword"
        />
      </div>
      <template #submit>
        <button type="submit" class="btn btn-primary btn-block btn-large">注册新用户</button>
      </template>
    </validate-form>
    </div>
    <h4 class="mt-4">在 vue template 中添加结构代码</h4>
    <pre class="language-html">
      <code v-html="highlightedCode"></code>
    </pre>
    <h4 class="mt-4">在 setup 方法中添加数据</h4>
    <pre class="language-javascript">
      <code v-html="highlightedCode2"></code>
    </pre>
    <h4>Dropdown 属性和事件</h4>
    <props-table :props="props"></props-table>
    <h4>DropdownItem 属性和事件</h4>
    <props-table :props="props2"></props-table>
  </div>
</template>

<script>
import { reactive } from 'vue'
import Prism from 'prismjs'
import ValidateInput, { RulesProp } from '../components/ValidateInput.vue'
import ValidateForm from '../components/ValidateForm.vue'
import PropsTable from '../components/PropsTable.vue'
export default {
  setup () {
    const formData = reactive({
      email: '',
      nickName: '',
      password: '',
      repeatPassword: ''
    })
    const emailRules = [
      { type: 'required', message: '电子邮箱地址不能为空' },
      { type: 'email', message: '请输入正确的电子邮箱格式' }
    ]
    const nameRules = [
      { type: 'required', message: '昵称不能为空' }
    ]
    const passwordRules = [
      { type: 'required', message: '密码不能为空' },
      { type: 'range', min: { message: '你的密码至少包括六位，不能含有空格', length: 6 } }
    ]
    const repeatPasswordRules = [
      { type: 'required', message: '重复密码不能为空' },
      { type: 'range', min: { message: '你的密码至少包括六位，不能含有空格', length: 6 } },
      {
        type: 'custom',
        validator: () => {
          return formData.password === formData.repeatPassword
        },
        message: '密码不相同'
      }
    ]
    const onFormSubmit = (result) => {
      if (result) {
        alert('🎉 通过啦')
      } else {
        alert('😢 没通过')
      }
    }
    return {
      emailRules,
      nameRules,
      passwordRules,
      repeatPasswordRules,
      onFormSubmit,
      formData
    }
  },
  data () {
    return {
      props: [
        { name: 'form-submit', type: '事件', desc: '回调参数 (result: boolean) => void, result 代表是否通过了验证' }
      ],
      props2: [
        { name: 'rules', type: 'array', desc: '单个输入框的验证类型，可以传入包含特定对象的数组, 详情可见上面示例代码' },
        { name: 'tag', type: 'input | textarea', desc: '根节点类型', default: 'input' },
        { name: 'v-model', type: 'string', desc: '支持 v-model，请对响应式数据' }
      ],
      code: `
      // html template
      <validate-form @form-submit="onFormSubmit">
        <div class="mb-3">
          <label class="form-label">邮箱地址</label>
          <validate-input
            :rules="emailRules" v-model="formData.email"
            placeholder="请输入邮箱地址"
            type="text"
          />
        </div>
        <div class="mb-3">
          <label class="form-label">昵称</label>
          <validate-input
            :rules="nameRules" v-model="formData.nickName"
            placeholder="请输入昵称"
            type="text"
          />
        </div>
        <div class="mb-3">
          <label class="form-label">密码</label>
          <validate-input
            type="password"
            placeholder="请输入密码"
            :rules="passwordRules"
            v-model="formData.password"
          />
        </div>
        <div class="mb-3">
          <label class="form-label">重复密码</label>
          <validate-input
            type="password"
            placeholder="请再次密码"
            :rules="repeatPasswordRules"
            v-model="formData.repeatPassword"
          />
        </div>
        <template #submit>
          <button type="submit" class="btn btn-primary btn-block btn-large">注册新用户</button>
        </template>
      </validate-form>
      `,
      code2: `
      // in script setup
  setup () {
    const formData = reactive({
      email: '',
      nickName: '',
      password: '',
      repeatPassword: ''
    })
    const emailRules = [
      // 多种规则
      { type: 'required', message: '电子邮箱地址不能为空' },
      { type: 'email', message: '请输入正确的电子邮箱格式' }
    ]
    const nameRules = [
      { type: 'required', message: '昵称不能为空' }
    ]
    const passwordRules = [
      { type: 'required', message: '密码不能为空' },
      // 范围规则
      { type: 'range', min: { message: '你的密码至少包括六位，不能含有空格', length: 6 } }
    ]
    const repeatPasswordRules = [
      { type: 'required', message: '重复密码不能为空' },
      { type: 'range', min: { message: '你的密码至少包括六位，不能含有空格', length: 6 } },
      // 自定义规则
      {
        type: 'custom',
        validator: () => {
          return formData.password === formData.repeatPassword
        },
        message: '密码不相同'
      }
    ]
    const onFormSubmit = (result) => {
      if (result) {
        alert('🎉 通过啦')
      } else {
        alert('😢 没通过')
      }
    }
    return {
      emailRules,
      nameRules,
      passwordRules,
      repeatPasswordRules,
      onFormSubmit,
      formData
    }
  },
      `
    }
  },
  computed: {
    highlightedCode () {
      return Prism.highlight(this.code, Prism.languages.html)
    },
    highlightedCode2 () {
      return Prism.highlight(this.code2, Prism.languages.javascript)
    }
  },
  components: {
    ValidateInput,
    ValidateForm,
    PropsTable
  }
}
</script>
